import { useEffect, useRef, useState, useCallback } from 'react';

interface AnimatedRumioIconProps {
  balance: number;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const sizeClasses = {
  sm: 'w-5 h-5',
  md: 'w-6 h-6',
  lg: 'w-7 h-7',
};

export default function AnimatedRumioIcon({
  balance,
  size = 'md',
  className = '',
}: AnimatedRumioIconProps) {
  const [isAnimating, setIsAnimating] = useState(false);
  const prevBalanceRef = useRef<number | null>(null);

  useEffect(() => {
    // Skip on initial mount
    if (prevBalanceRef.current === null) {
      prevBalanceRef.current = balance;
      return;
    }

    // Trigger animation when balance increases (async to satisfy lint)
    if (balance > prevBalanceRef.current) {
      const timeoutId = setTimeout(() => {
        setIsAnimating(true);
      }, 0);
      prevBalanceRef.current = balance;
      return () => clearTimeout(timeoutId);
    }

    prevBalanceRef.current = balance;
  }, [balance]);

  // Reset animation state when animation completes
  const handleAnimationEnd = useCallback(() => {
    setIsAnimating(false);
  }, []);

  return (
    <img
      src="/icons/rumio-ring.png?v=8"
      alt=""
      className={`${sizeClasses[size]} ${className} ${isAnimating ? 'animate-rumio-earn' : ''}`}
      onAnimationEnd={handleAnimationEnd}
    />
  );
}
